export default function initLayout() {
	document.querySelectorAll( 'form, input, textarea' ).forEach( ( element ) => {
		element.autocomplete = 'off';
		element.spellcheck = false;
		element.autocorrect = 'off';
	} );

	document.querySelectorAll( '#content iframe' ).forEach( ( iframe ) => {
		if ( iframe.previousElementSibling?.classList.contains( 'gform_wrapper' ) ) return;
		if ( ! iframe.parentElement.classList.contains( 'embed-container' ) ) {
			const wrapper = document.createElement( 'div' );
			wrapper.className = 'embed-container';
			iframe.parentNode.insertBefore( wrapper, iframe );
			wrapper.appendChild( iframe );
		}
	} );

	document.querySelectorAll( 'table' ).forEach( ( table ) => {
		if ( table.parentElement.classList.contains( 'responsive-table' ) ) return;
		const wrapper = document.createElement( 'div' );
		wrapper.className = 'responsive-table';
		table.parentNode.insertBefore( wrapper, table );
		wrapper.appendChild( table );
	} );

	const overlay = document.querySelector( '#mobile-menu' );
	const openButton = document.querySelector( '#mobile-menu-open' );
	const closeButton = document.querySelector( '#mobile-menu-close' );

	const closeMobileMenu = () => {
		if ( ! overlay?.classList.contains( 'is-open' ) ) return;
		overlay.classList.remove( 'is-open' );
		document.body.style.overflow = '';
		openButton?.focus();
	};

	openButton?.addEventListener( 'click', () => {
		overlay?.classList.add( 'is-open' );
		document.body.style.overflow = 'hidden';
		closeButton?.focus();
	} );
	closeButton?.addEventListener( 'click', closeMobileMenu );
	document.addEventListener( 'keydown', ( event ) => {
		if ( event.key === 'Escape' ) closeMobileMenu();
	} );
	overlay?.addEventListener( 'click', ( event ) => {
		if ( event.target === overlay ) closeMobileMenu();
	} );

	const getHeaderOffset = () => document.querySelector( '#site-header' )?.offsetHeight || 0;
	const scrollToTarget = ( target ) => {
		if ( ! target ) return;
		const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - 16;
		window.scrollTo( { top: Math.max( top, 0 ), behavior: 'smooth' } );
	};

	document.addEventListener( 'click', ( event ) => {
		const link = event.target.closest( 'a[href*="#"], [data-back-to-top]' );
		if ( ! link ) return;
		const href = link.getAttribute( 'href' );

		if ( link.matches( '[data-back-to-top]' ) ) {
			event.preventDefault();
			closeMobileMenu();
			window.scrollTo( { top: 0, behavior: 'smooth' } );
			return;
		}
		if ( ! href || href === '#' ) return;

		const url = new URL( href, window.location.href );
		const samePage = url.origin === window.location.origin &&
			url.pathname.replace( /\/$/, '' ) === window.location.pathname.replace( /\/$/, '' ) &&
			url.search === window.location.search;
		if ( ! samePage || ! url.hash ) return;

		const hash = decodeURIComponent( url.hash.slice( 1 ) );
		event.preventDefault();
		closeMobileMenu();
		if ( hash === 'top' ) {
			window.scrollTo( { top: 0, behavior: 'smooth' } );
		} else {
			scrollToTarget( document.getElementById( hash ) );
		}
		if ( window.history.pushState ) window.history.pushState( null, '', url.hash );
	} );

	const anchorLinks = Array.from( document.querySelectorAll( '#site-header a[href*="#"], #mobile-menu a[href*="#"]' ) )
		.map( ( link ) => {
			const url = new URL( link.href, window.location.href );
			const hash = decodeURIComponent( url.hash.slice( 1 ) );
			const samePage = url.origin === window.location.origin &&
				url.pathname.replace( /\/$/, '' ) === window.location.pathname.replace( /\/$/, '' ) &&
				url.search === window.location.search;
			const target = document.getElementById( hash );
			return samePage && hash && hash !== 'top' && target ? { link, hash, target } : null;
		} )
		.filter( Boolean );
	const initialActive = Array.from( document.querySelectorAll( '#site-header .nav-link--active, #mobile-menu .mobile-menu__link--active' ) );

	const setActiveAnchor = ( activeHash ) => {
		document.querySelectorAll( '#site-header .nav-link--active, #mobile-menu .mobile-menu__link--active' ).forEach( ( link ) => {
			link.classList.remove( 'nav-link--active', 'mobile-menu__link--active' );
		} );
		if ( ! activeHash ) initialActive.forEach( ( link ) => link.classList.add( link.classList.contains( 'mobile-menu__link' ) ? 'mobile-menu__link--active' : 'nav-link--active' ) );
		anchorLinks.filter( ( item ) => item.hash === activeHash ).forEach( ( item ) => item.link.classList.add( item.link.classList.contains( 'mobile-menu__link' ) ? 'mobile-menu__link--active' : 'nav-link--active' ) );
	};

	if ( anchorLinks.length && 'IntersectionObserver' in window ) {
		const visibleSections = new Map();
		const observer = new IntersectionObserver( ( entries ) => {
			entries.forEach( ( entry ) => {
				const item = anchorLinks.find( ( candidate ) => candidate.target === entry.target );
				if ( item ) visibleSections.set( item.hash, entry.isIntersecting ? entry.intersectionRatio : 0 );
			} );
			const activeHash = [ ...visibleSections.entries() ]
				.sort( ( a, b ) => b[ 1 ] - a[ 1 ] )[ 0 ]?.[ 0 ] || '';
			setActiveAnchor( activeHash );
		}, { rootMargin: `-${ getHeaderOffset() }px 0px -58%`, threshold: [ 0, 0.25, 0.5, 0.75, 1 ] } );
		anchorLinks.forEach( ( item ) => observer.observe( item.target ) );
	}

	const tocItems = Array.from( document.querySelectorAll( '.blog-single__toc-item' ) )
		.map( ( item ) => {
			const link = item.querySelector( 'a[href^="#"]' );
			const target = link ? document.getElementById( decodeURIComponent( link.hash.slice( 1 ) ) ) : null;
			return link && target ? { item, link, target } : null;
		} )
		.filter( Boolean );

	if ( tocItems.length && 'IntersectionObserver' in window ) {
		let activeTocItem = null;
		const tocOrder = new Map( tocItems.map( ( tocItem, index ) => [ tocItem, index ] ) );
		const tocObserver = new IntersectionObserver( ( entries ) => {
			const enteredItems = entries
				.filter( ( entry ) => entry.isIntersecting )
				.map( ( entry ) => tocItems.find( ( tocItem ) => tocItem.target === entry.target ) )
				.filter( Boolean )
				.sort( ( a, b ) => tocOrder.get( a ) - tocOrder.get( b ) );

			if ( enteredItems.length ) {
				activeTocItem = enteredItems[ enteredItems.length - 1 ];
			}

			tocItems.forEach( ( tocItem ) => {
				tocItem.item.classList.toggle( 'is-active', tocItem === activeTocItem );
				if ( tocItem === activeTocItem ) {
					tocItem.link.setAttribute( 'aria-current', 'location' );
				} else {
					tocItem.link.removeAttribute( 'aria-current' );
				}
			} );
		}, { rootMargin: `-${ getHeaderOffset() + 32 }px 0px -82% 0px`, threshold: 0 } );

		tocItems.forEach( ( tocItem ) => tocObserver.observe( tocItem.target ) );
	}

	window.addEventListener( 'scroll', () => {
		document.querySelector( '#site-header' )?.classList.toggle( 'is-scrolled', window.scrollY > 20 );
	}, { passive: true } );
	document.querySelectorAll( '.material-symbols-outlined' ).forEach( ( icon ) => {
		icon.style.fontVariationSettings = "'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24";
	} );
}
